import { render, staticRenderFns } from "./ar-button.vue?vue&type=template&id=51581387&scoped=true"
import script from "./ar-button.vue?vue&type=script&lang=js"
export * from "./ar-button.vue?vue&type=script&lang=js"
import style0 from "./ar-button.vue?vue&type=style&index=0&id=51581387&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51581387",
  null
  
)

export default component.exports